// Thread Design System Tokens
// Six distinguishable marks for the admin overview, one per engagement,
// drawn from the palette's own family (olive, pine, risk amber, plum, teal, clay).
export const ENGAGEMENT_COLOURS = ["#1f4a3d", "#8a6d20", "#7a4e7e", "#2f6b7a", "#9a5b3c", "#5a5d33"];

export const T = {
  // Core palette
  root: "#2e3105",
  pine: "#1f4a3d",
  canopy: "#b8bc7f",
  threadline: "#dee777",
  spark: "#dfe777",
  lumen: "#fffdc1",
  glow: "#feffe9",
  ink: "#000000",
  canvas: "#ffffff",
  mist: "#f7f7f7",
  soil: "#292b04",

  // Semantic
  bgPage: "#dee777",
  bgSurface: "#feffe9",
  bgSurfaceSoft: "#fffdc1",
  bgInverse: "#2e3105",
  bgBrand: "#1f4a3d",
  bgNeutral: "#f7f7f7",

  fgPrimary: "#2e3105",
  fgSecondary: "#5a5d33",
  fgMuted: "#8a8c6a",
  fgOnDark: "#feffe9",
  fgOnBrand: "#dee777",
  fgLink: "#2e3105",

  borderSubtle: "rgba(46, 49, 5, 0.12)",
  borderStrong: "rgba(46, 49, 5, 0.35)",
  borderOnDark: "rgba(254, 255, 233, 0.18)",

  accent: "#dee777",
  accentSoft: "#fffdc1",
  accentDark: "#1f4a3d",

  // Status
  statusOn: "#3a6b2a",
  statusOnBg: "rgba(58, 107, 42, 0.14)",
  statusRisk: "#8a6d20",
  statusRiskBg: "rgba(138, 109, 32, 0.16)",
  statusOff: "#8b3a2a",
  statusOffBg: "rgba(139, 58, 42, 0.15)",

  // Typography
  fontDisplay: "'Poppins', system-ui, -apple-system, sans-serif",
  fontSans: "'Poppins', system-ui, -apple-system, sans-serif",

  // Radii
  radiusSm: "6px",
  radiusMd: "12px",
  radiusLg: "20px",
  radiusXl: "28px",
  radiusPill: "999px",

  // Shadows
  shadowSm: "0 1px 2px rgba(46, 49, 5, 0.06)",
  shadowMd: "0 6px 18px rgba(46, 49, 5, 0.10)",
  shadowLg: "0 18px 40px rgba(46, 49, 5, 0.14)",
};
